module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    class: _vm.classes
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f81a7b12"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/icon/faicon-stack.vue
// module id = 724
// module chunks = 85